var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"divPdfViewPanel"}},[_c('iframe',{attrs:{"id":"iframe","src":_vm.documentLink,"width":"900px","height":"820px;"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }